import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WalletsPage.KycPage.wizard.AccountUsageThreeStep.StepForm', {
    letUsKnow: "Let us know a bit more about the countries and currencies you're interested in...",
    countriesInteractWith: 'What countries will you transact with?',
    countriesInteractWithPlaceholder: 'Select at least one country',
    currenciesSendIn: 'Currencies you will send in',
    currenciesSendInPlaceholder: 'Choose currencies you will send in',
    currenciesPayOut: 'Currencies you will pay out',
    currenciesPayOutPlaceholder: 'Choose currencies you will pay out',
});
